import React from 'react'
import PropTypes from 'prop-types'
import { Box, TextField, Select, MenuItem, InputAdornment } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { SEARCH_FIELDS } from '../../../../../constants/hold-allocation-constants'

function ListingSearchV2({ searchField, searchValue, onFieldChange, onValueChange }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
      <Select
        value={searchField}
        onChange={(e) => onFieldChange(e.target.value)}
        size='small'
        sx={{
          minWidth: 130,
          fontFamily: 'AtlasGroteskRegular, sans-serif',
          fontSize: '0.85rem',
          backgroundColor: '#ffffff',
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          '& .MuiOutlinedInput-notchedOutline': {
            borderRight: 'none',
            borderColor: '#d0d0d0',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#999',
            borderRight: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#145a4b',
            borderRight: 'none',
          },
        }}
      >
        {SEARCH_FIELDS.map((f) => (
          <MenuItem
            key={f.value}
            value={f.value}
            sx={{ fontFamily: 'AtlasGroteskRegular, sans-serif', fontSize: '0.85rem' }}
          >
            {f.label}
          </MenuItem>
        ))}
      </Select>
      <TextField
        size='small'
        placeholder='Enter Order ID'
        value={searchValue}
        onChange={(e) => onValueChange(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <SearchIcon sx={{ fontSize: 20, color: '#606060', cursor: 'pointer' }} />
            </InputAdornment>
          ),
        }}
        sx={{
          flex: 1,
          minWidth: 280,
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff',
            fontFamily: 'AtlasGroteskRegular, sans-serif',
            fontSize: '0.85rem',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d0d0d0',
            },
          },
        }}
      />
    </Box>
  )
}

ListingSearchV2.propTypes = {
  searchField: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onValueChange: PropTypes.func.isRequired,
}

export default ListingSearchV2
